module.exports = __webpack_public_path__ + "static/media/history-undo.45d73c35.svg";